import { DetailedProductFieldsFragment } from "client/graphql/storefront-api"

export type ProductVariant =
  DetailedProductFieldsFragment["variants"]["nodes"][0]

export const getDefaultVariantForProduct = (
  product: DetailedProductFieldsFragment,
): ProductVariant => {
  const firstAvailableVariant = product.variants.nodes.find((variant) => {
    return variant.availableForSale
  })
  return firstAvailableVariant ?? product.variants.nodes[0]
}
